import { CHAPTER } from "../chapter";

export function Mark({
  size = 32,
  // Warm gold glyph, matching the public sites' mark. Literal rather
  // than a token — it's the one brand-gold on an otherwise terracotta
  // palette, so it deliberately sits outside the theme tokens.
  colour = "#c97a2e",
  decorative = false,
}: {
  size?: number;
  colour?: string;
  /** True where the chapter name is printed right beside the mark, so a
   *  screen reader doesn't read the name twice. */
  decorative?: boolean;
}) {
  return (
    <span
      role={decorative ? undefined : "img"}
      aria-label={decorative ? undefined : CHAPTER.name}
      aria-hidden={decorative ? true : undefined}
      style={{
        display: "inline-block",
        flexShrink: 0,
        width: size,
        height: size,
        lineHeight: `${size}px`,
        fontSize: size * 1.08,
        color: colour,
        fontFamily: "var(--font-devanagari)",
        fontWeight: 400,
        textAlign: "center",
        userSelect: "none",
      }}
    >
      अ
    </span>
  );
}
